import TablaCobro from "./TablaCobro"
export default TablaCobro;